import React, { useEffect } from 'react'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute'

// Assets
import './assets/styles/main.scss'

// Pages
import Pedigree from './pages/Pedigree'
import NewPedigree from './pages/NewPedigree'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ChangePassword from './pages/ChangePassword'
import VerifyEmail from './pages/VerifyEmail'
import PremiumPlan from './pages/PremiumPlan'
import NewPremium from './pages/NewPremium'
import Catalogues from './pages/Catalogues'
import Transactions from './pages/Transactions'
import MyCredits from './pages/MyCredits'
import AdminFunctionalities from './pages/AdminFunctionalities'
import MembershipPayment from './pages/MembershipPayment'
import Home from './pages/Home'
import WebReport from './pages/WebReport'
import ReportCollection from './pages/ReportCollection'

import MyLists from './pages/MyLists'
import NewList from './pages/NewList'
import EditList from './pages/EditList'

import config from './api/config'
import TagManager from 'react-gtm-module'
import { isGtmEnabled } from './utils/gtm'
import MarketingEventDispatcher from './components/MarketingEventDispatcher'

// Contexts
import { UserProvider } from './contexts/UserContext'
import { OnboardingProvider } from './contexts/OnboardingContext'

import { authenticationService } from './api/authentication.service'
import { userService } from './api/user.service'

const tagManagerArgs = {
    gtmId: config.gtmId
}

if (isGtmEnabled()) TagManager.initialize(tagManagerArgs)


function App() {
	useEffect(() => {
        async function fetchAndUpdateUserDetails() {
            const currentUser = localStorage.getItem('currentUser')
            if (currentUser) {
                try {
                    const updatedUserData = await userService.details()
                    authenticationService.updateUserDetails(updatedUserData)
                } catch (error) {
                    console.error("Error actualizando los detalles del usuario", error)
                }
            }
        }
        fetchAndUpdateUserDetails()
    }, [])
	return (
	  <BrowserRouter>
		<UserProvider>
		  <MarketingEventDispatcher />
		  <OnboardingProvider>
		  <Routes>
			<Route path="/reports/collections/:kind/:id" element={<ReportCollection />} />
			<Route path="/reports/collections/:token" element={<ReportCollection />} />
            <Route path="/reports/:token" element={<WebReport />} />
            <Route path="/login" element={<Login />} />
			<Route path="/signup" element={<Signup />} />
			<Route path="/verify-email" element={<VerifyEmail />} />
			<Route path="/forgot-password" element={<ForgotPassword />} />
			<Route path="/change-password/:token" element={<ChangePassword />} />
			<Route path="/new-pedigree" element={<NewPedigree />} />
			<Route element={<PrivateRoute />}>
			  <Route path="/" element={<Home />} />
			  <Route path="/thank-you" element={<Home />} />
			  <Route path="/pedigree-analysis" element={<Pedigree />} />
			  <Route path="/membership" element={<MembershipPayment />} />
			  <Route path="/premium" element={<PremiumPlan />} />
			  <Route path="/new-premium" element={<NewPremium />} />
			  
			  <Route path="/catalogues" element={<Catalogues />} />

			  <Route path="/my-lists" element={<MyLists />} />
			  <Route path="/new-list" element={<NewList />} />
			  <Route path="/edit-list/:id" element={<EditList />} />

			  <Route path="/transactions" element={<Transactions />} />
			  <Route path="/my-credits" element={<MyCredits />} />
			  <Route path="/functionalities-for-admin" element={<AdminFunctionalities admin={true} />}/>
			</Route>
		  </Routes>
		  </OnboardingProvider>
		</UserProvider>
	  </BrowserRouter>
	);
  }

export default App;
